import { useId, useRef, useState } from 'react';
import { storage } from '../../firebase/config';
import { ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { TextInput } from '../../ui/components';

export default function ImageUploader({ label, value, onChange, storagePath = 'uploads' }) {
  const [progress, setProgress] = useState(null);
  const [error, setError]       = useState(null);
  const fileRef                 = useRef();
  const fileInputId             = useId();

  const handleFile = (file) => {
    if (!file) return;
    setError(null);
    const storageRef = ref(storage, `${storagePath}/${Date.now()}_${file.name}`);
    const task       = uploadBytesResumable(storageRef, file);

    task.on('state_changed',
      snap => setProgress(Math.round((snap.bytesTransferred / snap.totalBytes) * 100)),
      err  => { setError(err.message); setProgress(null); },
      async () => {
        const url = await getDownloadURL(task.snapshot.ref);
        onChange(url);
        setProgress(null);
      }
    );
  };

  const onDrop = (e) => {
    e.preventDefault();
    handleFile(e.dataTransfer.files[0]);
  };

  return (
    <div className="adm-field">
      {label && <label className="adm-label" htmlFor={fileInputId}>{label}</label>}

      <button
        type="button"
        className="adm-uploader ui-file-upload-trigger"
        onDragOver={event => event.preventDefault()}
        onDrop={onDrop}
        onClick={() => fileRef.current.click()}
      >
        {value
          ? <img src={value} alt="preview" className="adm-uploader__preview" />
          : <span className="adm-uploader__hint">Drag & drop or click to upload</span>
        }
        {progress !== null && (
          <div className="adm-uploader__progress">
            <div style={{ width: `${progress}%` }} />
          </div>
        )}
      </button>

      <TextInput
        type="text"
        className="adm-input"
        placeholder="…or paste image URL"
        value={value}
        onChange={e => onChange(e.target.value)}
        aria-label={`${label || 'Image'} URL`}
      />

      <input
        id={fileInputId}
        type="file"
        accept="image/*"
        ref={fileRef}
        style={{ display: 'none' }}
        onChange={e => handleFile(e.target.files[0])}
      />

      {error && <p className="adm-error">{error}</p>}
    </div>
  );
}
